var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrevOutlined = function SvgPrevOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 22.664c6.04 0 10.938-4.718 10.938-10.537 0-5.82-4.897-10.537-10.938-10.537-6.04 0-10.938 4.717-10.938 10.537 0 5.82 4.897 10.537 10.938 10.537Zm0 1.505c6.904 0 12.5-5.391 12.5-12.042S19.404.084 12.5.084 0 5.476 0 12.127c0 6.65 5.596 12.042 12.5 12.042Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.868 8.907-.98-1.152-4.166 4.903 4.167 4.904.979-1.152-3.18-3.752 3.18-3.75Z"
  })));
};
export default SvgPrevOutlined;